import React from 'react'
import { MaterialIcon, Tonality } from '@dsny/dsny-component-library'
import { Add } from '@dsny/dsny-component-library/icons'
import { REQUEST_NEW_LIST_URL } from 'utils/constants'

export const getStandardFilterSections = (moods, instruments, release_types) => [
  {
    key: 'mood',
    options: moods,
    titleKey: 'home.filter-mood-title',
    singleSelect: true // Radio button behavior
  },
  {
    key: 'instrument',
    options: instruments,
    titleKey: 'home.filter-instrument-title',
    singleSelect: true // Radio button behavior
  },
  {
    key: 'release_type',
    options: release_types,
    titleKey: 'home.filter-release-type-title',
    singleSelect: false // Multiple selection (checkbox behavior)
  }
]

export const getConditionalFilterSections = (
  packages,
  versions,
  markets,
  theme,
  t
) => [
  {
    key: 'package',
    options: packages,
    titleKey: 'home.filter-lists-title',
    condition: packages.length > 0,
    children: (
      <Tonality.UIText
        textStyle="body"
        style={{
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          flexBasis: '100%',
          gap: 8,
          cursor: 'pointer'
        }}
        color={theme.colors.player50}
        onClick={() => window.open(REQUEST_NEW_LIST_URL, '_blank')}
      >
        {t('home.filter-request-new-list')}
        <Add width={16} height={16} />
      </Tonality.UIText>
    )
  },
  {
    key: 'version',
    options: versions,
    titleKey: 'home.filter-song-version-title',
    condition: versions.length > 0,
    icon: (
      <MaterialIcon
        name="PlaylistPlay"
        color={theme.colors.neutralW70}
        style={{ fontSize: 16, marginRight: 8 }}
      />
    )
  },
  {
    key: 'market',
    options: markets,
    titleKey: 'home.filter-markets-title',
    condition: markets.length > 0,
    icon: (
      <MaterialIcon
        name="Public"
        color={theme.colors.neutralW70}
        style={{ fontSize: 16, marginRight: 8 }}
      />
    )
  }
]
